import { CORRELATION_ID_HEADER, correlationScope } from "@shared/lib/analytics"
import { InternalAxiosRequestConfig } from "axios"

export const correlationIdInterceptor = async (
	config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> => {
	config.headers[CORRELATION_ID_HEADER] = correlationScope.get()

	return config
}
